import { makeRequest } from '../client';

export const createShoutout = (data) => {
  return makeRequest('shoutout', 'createPublic', data);
};

export const getShoutoutAllowance = (data) => {
  return makeRequest('shoutout', 'getAllowance', data);
};

const getVisitorId = () => {
  const storageKey = 'supu_shoutout_visitor_id';
  const existing = localStorage.getItem(storageKey);
  if (existing) return existing;
  const visitorId = typeof window.crypto?.randomUUID === 'function'
    ? window.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  localStorage.setItem(storageKey, visitorId);
  return visitorId;
};

export const getShoutout = (token) => {
  return makeRequest('shoutout', 'getPublic', { token, visitor_id: getVisitorId() });
};
